import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ConfirmationModal = ({
  show,
  onHide,
  onConfirm,
  onCancel,
  title,
  body,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  confirmVariant = "primary",
  cancelVariant = "secondary",
  hideCancel = false,
  dataTestId,
}) => {
  // When onCancel is not provided, fall back to onHide so existing callers keep
  // their current behaviour (cancel button dismisses the modal).
  const handleCancel = onCancel || onHide;
  const testIdProps = dataTestId ? { "data-testid": dataTestId } : {};
  return (
    <Modal show={show} onHide={onHide} centered {...testIdProps}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{body}</Modal.Body>
      <Modal.Footer>
        {!hideCancel && (
          <Button
            variant={cancelVariant}
            onClick={handleCancel}
            data-testid={dataTestId ? `${dataTestId}-cancel` : undefined}
          >
            {cancelLabel}
          </Button>
        )}
        <Button
          variant={confirmVariant}
          onClick={onConfirm}
          data-testid={dataTestId ? `${dataTestId}-confirm` : undefined}
        >
          {confirmLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
